module.exports = __webpack_public_path__ + "img/exportTXTWhite.48999422.svg";